<script setup lang="ts">
import { computed } from 'vue';
import { Loader2 } from "lucide-vue-next";
import { useColorMode } from "@vueuse/core";

// Define props with defaults
const props = withDefaults(defineProps<{
  hideLogo?: boolean;
  hideSpinner?: boolean;
  spinnerSize?: number;
}>(), {
  hideLogo: false,
  hideSpinner: false,
  spinnerSize: 100,
});


const mode = useColorMode();
const logoSrc = computed(() =>
  mode.value === "dark"
    ? "https://cdn.aplos-nca.com/assets/MonoLogoWhite.svg"
    : "https://cdn.aplos-nca.com/assets/ColorLogo.svg"
);
</script>

<template>
  

  <div class="flex flex-col items-center justify-center">
    <Loader2 v-if="!props.hideSpinner" class="animate-spin mb-4" :size="props.spinnerSize" />
    <img v-if="!props.hideLogo" :src="logoSrc" class="mb-4 h-14" alt="Loading Logo" />
  </div>
</template>
